import { render, staticRenderFns } from "./ListMateriales.vue?vue&type=template&id=0a67e59c&"
import script from "./ListMateriales.vue?vue&type=script&lang=js&"
export * from "./ListMateriales.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports